export default {
  api_r_user_login: {
    path: 'login',
  },
  api_r_user_2fa_verify: {
    path: '2fa/verify',
  },
  
};
